import sileo from 'sileo';

const LeaveRequest = new sileo.Model('hqzen', 'leave-request');
const OvertimeRequest = new sileo.Model('hqzen', 'overtime-request');
const CriticalWorkingDaysRequest = new sileo.Model('hqzen', 'critical-working-day-request');
const Department = new sileo.Model('hqzen', 'requests-departments');
const Team = new sileo.Model('hqzen', 'requests-teams');
const TimelogRequest = new sileo.Model('hqzen', 'timelog-issue-request');
const Comments = new sileo.Model('hqzen', 'comments-request');
const LeaveTypes = new sileo.Model('hqzen', 'hr-leave-type');

const actions = {
    fetchLeaveRequest(context, filters) {
        return LeaveRequest.objects.filter(filters);
    },

    fetchLeaveTypes(context, id) {
        return LeaveTypes.objects.get(id);
    },

    fetchOvertimeRequest(context, filters) {
        return OvertimeRequest.objects.filter(filters);
    },

    fetchCriticalWorkingDaysRequest(context, filters) {
        return CriticalWorkingDaysRequest.objects.filter(filters);
    },

    fetchDepartments(context, filters) {
        return Department.objects.filter(filters);
    },

    fetchTeams(context, filters) {
        return Team.objects.filter(filters);
    },

    fetchTimelogRequest(context, filters) {
        return TimelogRequest.objects.filter(filters);
    },

    resolveIssue(context, pk) {
        let data = new FormData();
        data.append('action', 'resolve');
        return TimelogRequest.objects.update({ pk: pk }, data);
    },

    rejectIssue(context, data) {
        let form = new FormData();
        form.append('action', 'reject');
        form.append('remarks', data.rejectReason);
        return TimelogRequest.objects.update({ pk: data.pk }, form);
    },

    createResponse(context, filters) {
        return Comments.objects.create({
            'issue_id': filters.issue_id,
            'comment_text': filters.response
        });
    },

    updateLeaveRequest(context, data) {
        let form = new FormData();
        form.append('status', data.status);
        form.append('signature_uuid', data.signature_uuid);
        form.append('location', data.location);
        if (form.get('status') === 'rejected') {
            form.append('reject_reason', data.reason);
        }
        return LeaveRequest.objects.update({ pk: data.pk }, form);
    },

    updateOvertimeRequest(context, data) {
        let form = new FormData();
        form.append('status_display', data.status_display);
        return OvertimeRequest.objects.update({ pk: data.pk }, form);
    }
};

export default {
    namespaced: true,
    actions
};
